module.exports = __webpack_public_path__ + "static/img/ai-comic-homepage.9eac70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/ai-comic-homepage.png
// module id = Xq07
// module chunks = 1